class Menu {
    static init() {
        this.html = document.querySelector("html");
        this.lastHtmlTop = null;
        this.header = document.querySelector(".header");
        this.sticky = document.querySelector(".header__sticky");
        this.items = document.querySelectorAll(".menu-item:not(.btn-blue)");
        this.barre = document.querySelector(".header__menu__trait");
        this.currentItem = document.querySelector(".current-menu-item");
        this.lastItem = null;

        if (this.barre) {
            this.items.forEach(item => {
                item.addEventListener("mouseenter", () => {
                    this.currentItem = item;
                    this.render();
                });
            });

            this.barre.addEventListener("transitionend", () => {
                this.barre.classList.remove("header__menu__trait--withTransition");
            })
        }

        if (this.header && this.header.classList.contains("header--noImage")) {
            this.html.classList.add("html--noImageHeader");
        }

        this.render();
    }

    static render() {
        //Gestion du RollHover
        if (this.currentItem) {

            if (this.lastItem !== this.currentItem) {
                this.lastItem = this.currentItem;
                this.barre.classList.add("header__menu__trait--withTransition");
            }

            let info = this.currentItem.getBoundingClientRect();
            let left = this.currentItem.offsetLeft;
            let width = info.width;
            this.barre.style.width = width + "px";
            this.barre.style.left = left + "px";
        }

        if (this.sticky) {
            let htmlTop = this.html.getBoundingClientRect().top;
            if (this.lastHtmlTop !== htmlTop) {
                this.lastHtmlTop = htmlTop;
                if (htmlTop < - 85) {
                    this.sticky.classList.add("header__sticky--sticky")
                } else {
                    this.sticky.classList.remove("header__sticky--sticky")
                }

            }
        }

        requestAnimationFrame(() => this.render());
    }
}

export default Menu;


// WEBPACK FOOTER //
// ./src/scripts/components/menu.js